module.exports = __webpack_public_path__ + "static/media/communitySelected.cf8f60ef.svg";